import { render, staticRenderFns } from "./equation-dialog.vue?vue&type=template&id=04a45097&"
import script from "./equation-dialog.vue?vue&type=script&lang=js&"
export * from "./equation-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports